export class ConsumidorPrevisaoModel {

  public consumidorId: number;
  public cpfBase: number;
  public cpfDigito: number;
  public numSorteioPremiacaoConsumidor: number;
  public desSorteio: string;
  public dataInicioPeriodo: string;
  public dataFinalPeriodo: string;
  public valTotalNotaFiscalParticipante: number;
  public qtd_bilhetes: number;
}



// WEBPACK FOOTER //
// ./src/app/restrito/consumidor/shared/consumidor-previsao.model.ts